import React from 'react';
import {OrganTree} from '../../public'
import './index.less'
import UserGrid from './UserGrid'
import api, { AppOrgan } from "api";

export default class extends React.Component<IPage> {
	state = { organId:0 }

	handleOrganChange = (data:AppOrgan) => {
		if(this.state.organId !== data.id){
            this.setState({organId:data.id})
        }
    }
    
	render() {
        let {organId} = this.state;
		return (
		<div className='page-application-user-container'>
			 <div className='page-user-content'>
                <div className='page-user-left'>
                    <div className='page-user-organ-mune'>
                        <span>组织架构</span>
                    </div>
                    <div className='page-user-organ-content'>
                        <OrganTree showButton onClick={this.handleOrganChange}/>
                    </div>
                </div>
                <div className='page-user-right'>
                    <UserGrid key={organId} organId={organId}/>
                </div>
             </div>
		</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/page/application/user/index.tsx